var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content-loading",attrs:{"id":"loading-consulta"}},[_c('img',{attrs:{"src":require("./../../assets/images/pages/logo-soc-nuevo.png"),"alt":""}}),_c('h3',[_vm._v("Procesando... ")])])
}]

export { render, staticRenderFns }